// Textes de la page d'accueil (Home.jsx).
// RÈGLE : les valeurs françaises sont le texte EXACT du site d'avant la
// traduction — on ne réécrit pas la copie en passant.
export default {
  'home.seo.titre': 'Joyful Reveal - Jeu Gender Reveal : jouez pour révéler le sexe de bébé | Mirum Games',
  'home.seo.description': 'Transformez votre gender reveal party en jeu : 2 équipes, des questions drôles, 11 pièces de puzzle à gagner et une pièce finale qui révèle le sexe de bébé. Livraison rapide en Belgique et en France.',

  'home.etat.chargement': 'Chargement...',

  'home.vitrine.badge': '🧩 Notre Collection',
  'home.vitrine.description': 'Un concept unique qui transforme la révélation du sexe de bébé en un jeu de questions-réponses amusant ! Rassemblez vos proches, formez des équipes et vivez ensemble ce moment magique qui restera gravé dans vos mémoires.',
  'home.vitrine.altProduit': 'Joyful Reveal Ours - Puzzle révélation sexe bébé écologique - Mirum Games',

  'home.packs.titre': 'Choisissez votre Pack',
  'home.packs.economisez': 'Économisez {pct}%',
  'home.packs.selectionne': '✓ Sélectionné',
  'home.packs.selectionner': 'Sélectionner',
  'home.packs.voirFiche': '📋 Voir la fiche complète',

  'home.recap.packChoisi': 'Pack choisi:',
  'home.recap.prixTotal': 'Prix Total:',

  'home.genre.cestPour': "C'est pour...",
  'home.genre.contenuPack': 'Contenu du pack',
  'home.genre.packMixte': 'Pack Mixte : Fille + Garçon inclus !',
  'home.genre.versionGarcon': 'Version Garçon pré-sélectionnée',
  'home.genre.versionFille': 'Version Fille pré-sélectionnée',

  // Libellés de variante : servent aux boutons Garçon/Fille ET au nom composé
  // du produit ajouté au panier (une clé par variante).
  'home.variante.garcon': 'Garçon',
  'home.variante.fille': 'Fille',
  'home.variante.mixte': 'Fille + Garçon',

  'home.cta.ajouterPanier': '🛒 Ajouter au Panier',
  'home.cta.voirFichePack': '📋 Voir la fiche complète du {pack}',
  'home.cta.magique': '✨ Créez un moment magique avec votre famille',

  'home.badges.cleEnMain': 'Clé en Main',
  'home.badges.pretAOffrir': 'Prêt à Offrir',
  'home.badges.livraisonRapide': 'Livraison Rapide',

  'home.concept.badge': '✨ Notre Concept Unique',
  // Phrases découpées autour des <strong> : avant / mot fort / après.
  'home.concept.question': 'Une petite fille ? Un petit garçon ?',
  'home.concept.questionSuite': "Tout le monde autour de vous s'impatiente de savoir de quelle team sera votre futur bébé ?",
  'home.concept.annonce': 'Annoncez cette nouvelle de manière ludique et originale avec notre jeu!',
  'home.concept.puzzleAvant': 'Ce puzzle est',
  'home.concept.puzzleMot': 'unique',
  'home.concept.puzzleApres': 'car il se construit en participant à un jeu de questions réponses amusantes, pour finalement révéler le petit secret de bébé.',
  'home.concept.experienceAvant': "Bien plus qu'un puzzle, il s'agit d'une",
  'home.concept.experienceMot': 'expérience de partage et de joie',
  'home.concept.experienceApres': 'entre amis et en famille. Rassemblez vos proches, formez des équipes et profitez de ce moment unique dans votre vie!',
  'home.concept.cadeauAvant': 'Que vous soyez un couple de futurs parents, ou que vous organisiez une',
  'home.concept.cadeauMot': 'Gender Reveal Party',
  'home.concept.cadeauApres': "pour un être cher, notre jeu rendra assurément l'événement encore plus mémorable.",

  'home.instagram.badge': '📸 Moments Magiques',
  'home.instagram.titre': 'Découvrez Notre Puzzle en Action ! 🎉',
  'home.instagram.sousTitre': 'Regardez comment nos clients vivent leur révélation magique avec Joyful Reveal',
  'home.instagram.altReel': 'Deux futurs parents entourés de pièces de puzzle, illustration Joyful Reveal',
  'home.instagram.voirSur': 'Voir sur Instagram',
  'home.instagram.momentTitre': 'Un Moment Inoubliable',
  'home.instagram.momentTexte': 'Nos puzzles transforment la révélation en une expérience interactive et festive. Assemblez les pièces en famille et découvrez ensemble le grand secret !',
  'home.instagram.jeuInteractif': 'Jeu Interactif',
  'home.instagram.enFamille': 'En Famille',
  'home.instagram.suivezNous': 'Suivez-nous sur Instagram',
};
